import type { Strings } from './types'

export const es: Strings = {
  common: {
    back: 'Atrás',
    continue: 'Continuar',
    cancel: 'Cancelar',
    close: 'Cerrar',
    retry: 'Reintentar',
    loading: 'Cargando…',
    save: 'Guardar',
    follow: 'Seguir',
    following: 'Siguiendo',
    showMenu: 'Mostrar menú',
    appbarBack: 'Volver',
    appbarClose: 'Cerrar',
    administration: 'Administración',
    adminPanel: 'Admin Panel',
    adminLite: 'Admin Lite',
  },
  language: {
    spanish: 'Español',
    english: 'English',
  },
  auth: {
    errors: {
      noConnection: 'Sin conexión. Revisá tu internet e intentá de nuevo.',
      invalidCredentials: 'Credenciales inválidas. Revisá tu email y contraseña.',
      duplicateAccount: 'Ya existe una cuenta con ese email o usuario.',
      invalidCode: 'Código inválido. Pedí uno nuevo e intentá de nuevo.',
    },
    login: {
      title: 'Bienvenido',
      subtitle: 'Iniciá sesión para continuar',
      credentialLabel: 'Email, usuario o teléfono',
      passwordLabel: 'Contraseña',
      showPassword: 'Mostrar contraseña',
      hidePassword: 'Ocultar contraseña',
      forgotPassword: '¿Olvidaste tu contraseña?',
      submit: 'Iniciar Sesión',
      divider: 'o',
      useBiometrics: 'Usar biometría',
      noAccount: '¿No tenés cuenta?',
      signUpLink: 'Registrate',
      credentialRequired: 'Ingresá tu email, usuario o teléfono',
      passwordRequired: 'Ingresá tu contraseña',
      passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
      biometricNotEnrolled: 'Primero configurá la biometría en tu perfil',
      biometricUnavailable: 'Biometría no disponible en este dispositivo',
      biometricFailed: 'Biometric authentication failed',
    },
    register: {
      title: 'Crear cuenta',
      subtitle: 'Completá tus datos para registrarte',
      progressLabel: 'Progreso del registro',
      stepAccount: 'Cuenta',
      stepUsername: 'Usuario',
      stepPassword: 'Contraseña',
      stepContact: 'Contacto',
      chooseAccountType: 'Elegí tu tipo de cuenta',
      accountClient: 'Cliente',
      accountClientDescription: 'Mirá contenido y seguí a tus creadores',
      accountCreator: 'Creador',
      accountCreatorDescription: 'Publicá contenido y ganá dinero',
      accountAgency: 'Agencia',
      accountAgencyDescription: 'Gestioná creadores y campañas',
      kycNote: 'Las cuentas de creador y agencia requieren verificación de identidad (KYC).',
      usernameLabel: 'Nombre de usuario',
      usernamePlaceholder: '@usuario',
      checkingAvailability: 'Verificando disponibilidad',
      usernameAvailable: 'Nombre disponible',
      availableMessage: '¡Disponible!',
      takenMessage: 'Ese usuario ya está ocupado, elegí otro',
      suggestionsHint: 'Probá con:',
      passwordLabel: 'Contraseña',
      confirmPasswordLabel: 'Confirmar contraseña',
      showPassword: 'Mostrar contraseña',
      hidePassword: 'Ocultar contraseña',
      strengthPrefix: 'Fortaleza',
      passwordRequired: 'Ingresá una contraseña',
      passwordTooShort: 'Mínimo 8 caracteres',
      passwordsMismatch: 'Las contraseñas no coinciden',
      methodLabel: 'Método de registro',
      methodEmail: 'Email',
      methodPhone: 'Teléfono',
      genderLabel: 'Género (opcional)',
      genderMale: 'Hombre',
      genderFemale: 'Mujer',
      genderUnspecified: 'No especificado',
      emailLabel: 'Email',
      phoneLabel: 'Teléfono',
      phonePlaceholder: '+54 9 11 1234-5678',
      emailRequired: 'Ingresá tu email',
      emailInvalid: 'Email inválido',
      phoneRequired: 'Ingresá tu teléfono',
      submit: 'Crear Cuenta',
      terms: 'Al registrarte aceptás los Términos y Condiciones',
      successTitle: '¡Cuenta creada!',
      username: {
        required: 'Ingresá un nombre de usuario',
        tooShort: 'Mínimo 3 caracteres',
        tooLong: 'Máximo 30 caracteres',
        invalidChars: 'Solo letras, números, punto y guion bajo',
        edgeChar: 'No puede empezar ni terminar con punto o guion bajo',
        consecutiveSeparators: 'No uses puntos o guiones bajos seguidos',
      },
      strength: {
        weak: 'Débil',
        fair: 'Aceptable',
        strong: 'Fuerte',
        veryStrong: 'Muy fuerte',
      },
    },
    sms: {
      title: 'Verificá tu número',
      noVerifiedPhone: 'No tenés un teléfono verificado todavía.',
      addPhoneToContinue: 'Agregá tu número de teléfono para continuar.',
      phoneLabel: 'Teléfono',
      phonePlaceholder: '+54 9 11 1234-5678',
      sendCode: 'Enviar código',
      codeSentPrefix: 'Te enviamos un código a',
      codeLabel: 'Código de verificación',
      verify: 'Verificar',
      resendCountdownPrefix: 'Reenviar código en',
      resend: 'Reenviar código',
      verifiedOk: 'Código verificado correctamente',
    },
    forgot: {
      requestTitle: 'Recuperá tu contraseña',
      requestSubtitle: 'Ingresá tu email, usuario o teléfono y te enviamos un código para crear una nueva',
      credentialLabel: 'Email, usuario o teléfono',
      sendCode: 'Enviar código',
      credentialRequired: 'Ingresá tu email, usuario o teléfono',
      confirmTitle: 'Verificá el código',
      codeSentPrefix: 'Te enviamos un código a',
      edit: 'Editar',
      codeLabel: 'Código de verificación',
      codeLengthError: 'Ingresá el código de 6 dígitos',
      newPasswordLabel: 'Nueva contraseña',
      confirmPasswordLabel: 'Confirmar contraseña',
      showPassword: 'Mostrar contraseña',
      hidePassword: 'Ocultar contraseña',
      passwordRequired: 'Ingresá una contraseña',
      passwordTooShort: 'Mínimo 8 caracteres',
      passwordsMismatch: 'Las contraseñas no coinciden',
      updatePassword: 'Actualizar contraseña',
      resendCountdownPrefix: 'Reenviar código en',
      resend: 'Reenviar código',
      doneTitle: 'Contraseña actualizada',
      doneSubtitle: 'Ya podés iniciar sesión con tu nueva contraseña',
      loginButton: 'Iniciar sesión',
      invalidOrExpiredCode: 'El código es inválido o venció. Pedí un código nuevo e intentá de nuevo.',
    },
    biometric: {
      title: 'Protegé tu cuenta',
      subtitle: 'Elegí cómo querés desbloquear la app',
      biometricTitle: 'Face ID / Huella',
      biometricSubtitle: 'Usá tu biometría para entrar más rápido',
      pinTitle: 'Código PIN',
      pinSubtitle: 'Un PIN de 6 dígitos como respaldo',
      skip: 'Omitir por ahora',
      comingSoon: 'Próximamente',
      unsupportedDevice: 'Este dispositivo no soporta biometría',
      authFailed: 'Autenticación biométrica fallida',
      errorPrefix: 'Error',
    },
  },
  profile: {
    genderLabel: 'Género',
    genderMale: 'Hombre',
    genderFemale: 'Mujer',
    genderUnspecified: 'No especificado',
    statsPosts: 'Publicaciones',
    statsFollowers: 'Seguidores',
    statsFollowing: 'Seguidos',
    editTitle: 'Editar Perfil',
    save: 'Guardar',
    saveChanges: 'Guardar cambios',
    changeAvatar: 'Cambiar avatar',
    displayName: 'Nombre para mostrar',
    bio: 'Bio',
    username: 'Usuario',
    required: 'Requerido',
    invalidUsername: 'Usuario inválido',
    usernameAvailable: 'Usuario disponible',
    usernameTaken: 'Usuario en uso',
    usernameCheckFailed: 'No se pudo verificar disponibilidad',
    usernameFormat: '3–30 caracteres; solo letras, números, puntos y guiones bajos',
    usernameChanged: 'Usuario cambiado. Iniciá sesión de nuevo.',
    profileUpdated: 'Perfil actualizado',
    avatarUpdated: 'Avatar actualizado',
    avatarDeleted: 'Avatar eliminado',
    galleryTitle: 'Tus avatares',
    galleryEmpty: 'No hay avatares guardados',
    selectAvatar: 'Seleccionar avatar {index}',
    deleteAvatar: 'Eliminar avatar {index}',
    deleteAvatarTitle: 'Eliminar avatar',
    deleteAvatarBody: '¿Querés eliminar esta foto de tu galería?',
    deleteCancel: 'Cancelar',
    deleteConfirm: 'Eliminar',
    takePhoto: 'Tomar foto',
    chooseGallery: 'Elegir de la galería',
    viewGallery: 'Ver galería',
    editProfile: 'Editar Perfil',
    share: 'Compartir',
    wallet: 'Wallet',
    unlockedContent: 'Contenido desbloqueado',
    games: 'Juegos',
    settings: 'Configuración',
    help: 'Ayuda',
    logout: 'Cerrar Sesión',
    shareTitle: 'Compartir perfil',
    shareHeading: 'Compartí tu perfil con quien quieras',
    shareBody: 'Escaneá el QR o compartí el enlace para que te sigan en Lolax Models.',
    shareCopied: 'Enlace copiado al portapapeles',
    copyLink: 'Copiar enlace',
    shareButton: 'Compartir',
    shareInviteTitle: 'Lolax Models — {name}',
    shareInviteText: 'Unite a mí en Lolax Models: {link}',
    moreOptions: 'Más opciones',
    tabPosts: 'Publicaciones',
    tabReels: 'Reels',
    tabEncounters: 'Encuentros',
    reelsSoon: 'Reels próximamente',
    encountersSoon: 'Encuentros próximamente',
    noPosts: 'Sin publicaciones todavía',
    profileLoadFailed: 'No se pudo cargar el perfil.',
    profileUnavailable: 'Este perfil no está disponible.',
    followFailed: 'No se pudo completar la acción',
    avatarFormatError: 'Formato no válido o imagen demasiado grande',
    avatarUploadFailed: 'No se pudo subir el avatar',
    avatarSetFailed: 'No se pudo cambiar el avatar',
    avatarDeleteFailed: 'No se pudo eliminar el avatar',
    usernameErrFormat: 'Formato de usuario inválido',
    usernameErrTaken: 'Usuario en uso',
    usernameErrFailed: 'No se pudo cambiar el usuario',
    usernameErrRateLimit: 'Podés cambiar tu usuario de nuevo en 30 días',
    usernameErrSession: 'Sesión expirada. Iniciá sesión de nuevo.',
    profileSaveFailed: 'No se pudo actualizar el perfil',
    retry: 'Reintentar',
    unlockedToast: 'Publicación desbloqueada',
    comingSoon: 'Próximamente',
    unlockedTitle: 'Contenido desbloqueado',
    unlockedEmptyTitle: 'Todavía no hay contenido desbloqueado',
    unlockedEmptyBody: 'Las publicaciones premium que desbloquees van a aparecer acá',
    unlockedEnd: 'No hay más publicaciones desbloqueadas',
  },
  kyc: {
    extendedReviewNotice: 'Tu verificación necesita una revisión extendida: puede tomar más tiempo',
    chipNone: 'No verificado',
    chipPending: 'En revisión',
    chipVerified: 'Verificado',
    chipRejected: 'Rechazado',
    cardNone: 'No verificado',
    cardPending: 'En revisión',
    cardVerified: 'Verificación aprobada',
    cardRejected: 'Verificación rechazada',
    actionVerify: 'Verificar ahora',
    actionRetry: 'Reintentar',
    subNone: 'Para publicar contenido premium necesitás verificar tu identidad.',
    subPending: 'Enviado el {date} · tiempo estimado 24-48h',
    subVerified: 'Ya podés publicar contenido premium.',
    subRejectedNoReason: 'Tu documento no fue aceptado. Intentá de nuevo.',
    subRejectedReason: 'Motivo: {reason}',
    rowTitle: 'Estado de verificación KYC',
    rowNone: 'Sin verificar',
    rowPending: 'Documento en revisión',
    rowVerified: 'Identidad verificada',
    rowRejected: 'Documento rechazado',
    offline: 'Sin conexión, mostrando último estado',
    uploading: 'Subiendo documento…',
    loadingStatus: 'Cargando estado de verificación',
    staleData: 'Datos desactualizados',
    errNotRequired: 'Solo las cuentas Creator y Agencia requieren KYC.',
    errPending: 'Ya tenés un envío en revisión.',
    errMaxAttempts: 'Has alcanzado el máximo de intentos. Contactanos a soporte.',
    errTooLarge: 'El archivo es demasiado grande. Máximo 20MB.',
    errBadFormat: 'Tipo de archivo no soportado. Usa JPG, PNG o PDF.',
    errRequired: 'Adjuntá un documento de identidad antes de enviar.',
    errFallback: 'No pudimos enviar tu documento. Intentá de nuevo.',
    loadingLabel: 'Cargando…',
    uploadingLabel: 'Subiendo…',
    processingLabel: 'Procesando…',
    loadFailed: 'No pudimos obtener tu estado de verificación.',
    retry: 'Reintentar',
    uploadDocument: 'Subir documento',
  },
  wallet: {
    buyDiamonds: 'Comprar Diamantes',
    packages: 'Paquetes',
    popular: 'POPULAR',
    bestValue: 'MEJOR VALOR',
    bonus: '+{n} extra',
    recent: 'Actividad reciente',
    emptyActivity: 'No hay actividad reciente',
    selectPackage: 'Seleccioná un paquete',
    confirm: 'Confirmar',
    payTitle: 'Pagar',
    packageUnavailable: 'Paquete no disponible.',
    back: 'Volver',
    methodLabel: 'Método de pago',
    methodWompi: 'Tarjeta (Wompi)',
    methodCrypto: 'Cripto',
    summaryDiamonds: '{total} Diamantes',
    summaryBonus: 'Incluye {n} de bonificación',
    wompiUnavailable: 'Pagos con tarjeta no disponibles.',
    payIntro: 'Pagás {price} con tarjeta. El cobro se hace en pesos colombianos.',
    cardNumber: 'Número de tarjeta',
    expMonth: 'Mes de vencimiento',
    expYear: 'Año de vencimiento',
    monthPlaceholder: 'MM',
    yearPlaceholder: 'AA',
    cvc: 'CVC',
    holder: 'Titular de la tarjeta',
    installments: 'Cuotas',
    installmentOne: '{n} cuota',
    installmentMany: '{n} cuotas',
    email: 'Correo electrónico',
    emailPlaceholder: 'tu@correo.com',
    acceptTermsA: 'Acepto los',
    termsLink: 'términos y condiciones',
    acceptTermsB: 'del pago.',
    authDataA: 'Autorizo el tratamiento de mis datos personales',
    authDataLink: '(ver autorización)',
    validating: 'Validando tu tarjeta…',
    processing: 'Procesando el pago…',
    confirming: 'Confirmando el pago de {amount}…',
    payButton: 'Pagar {price}',
    purchaseSuccess: 'Compra exitosa',
    paymentDeclined: 'El pago fue rechazado. Revisá los datos de tu tarjeta o probá con otra.',
    pendingTitle: 'Pago en proceso',
    pendingBody: 'Recibimos tu pago y lo estamos confirmando. Tus diamantes aparecen en tu billetera en unos minutos.',
    backToWallet: 'Volver a la billetera',
    cryptoPendingTitle: 'Pago en revisión',
    cryptoPendingBody: 'Ya registramos tu hash. Un administrador lo confirma y tus {n} diamantes aparecen en tu billetera.',
    sendExactA: 'Enviá exactamente',
    sendExactB: 'en',
    sendExactC: 'a esta dirección',
    depositAddress: 'Dirección de depósito',
    copied: '¡Copiada!',
    copyAddress: 'Copiar dirección',
    receiveDiamonds: 'Recibís {n} diamantes',
    txHash: 'Hash de la transacción',
    txPlaceholder: 'Pegá el hash de tu envío',
    sentIt: 'Ya lo envié',
    selectIntroA: 'Pagás',
    selectIntroB: 'en cripto. Elegí la moneda:',
    viewAddress: 'Ver dirección de pago',
    errors: {
      loadFailed: 'No se pudo cargar la billetera.',
      noConnection: 'Sin conexión a internet. Intentá de nuevo.',
      sessionExpired: 'Sesión expirada. Iniciá sesión de nuevo.',
      insufficient: 'Diamantes insuficientes o solicitud inválida.',
      giftFailed: 'No se pudo enviar el regalo.',
      giftSent: 'Regalo enviado. Saldo restante: {balance}',
      cryptoIntentFailed: 'No pudimos crear la intención de pago.',
      cryptoHashFailed: 'No pudimos registrar tu hash.',
      wompiAcceptanceFailed: 'No pudimos cargar los términos de pago.',
      wompiUnavailable: 'Pagos con tarjeta no disponibles.',
      wompiNoConnection: 'No hay conexión con el procesador de pagos.',
      wompiCardRejected: 'Tu tarjeta fue rechazada. Revisá los datos.',
      wompiCardInvalid: 'No pudimos validar tu tarjeta.',
      wompiPurchaseFailed: 'No pudimos iniciar la compra.',
    },
  },
  games: {
    lobbyTitle: 'Juegos',
    lobbyLoading: 'Cargando juegos',
    retry: 'Reintentar',
    comingSoon: 'Próximamente',
    unavailable: 'No disponible por el momento',
    unavailableBadge: 'No disponible',
    playNow: 'Jugar ahora',
    titleSlots: 'Slots',
    titleBlackjack: 'Blackjack',
    titleDarts: 'Dardos',
    tagSlots: 'Girá los rodillos neón y ganá diamantes.',
    tagBlackjack: 'Llegá a 21 contra el dealer.',
    tagDarts: 'Desafiá amigos en un clásico 501.',
    backToGames: 'Volver a juegos',
    balanceAria: 'Saldo: {n} diamantes. Abrir billetera.',
    betLabel: 'Apuesta',
    betAmount: 'Monto de apuesta',
    betRange: 'La apuesta debe estar entre {min} y {max}',
    errors: {
      noConnection: 'Sin conexión a internet. Intentá de nuevo.',
      sessionExpired: 'Sesión expirada. Iniciá sesión de nuevo.',
      notEnough: 'Diamantes insuficientes',
      completePrevious: 'Terminá el juego anterior primero',
      loadSlots: 'No se pudieron cargar las slots.',
      spinFailed: 'No se pudo girar.',
      loadBlackjack: 'No se pudo cargar el blackjack.',
      loadStats: 'No se pudieron cargar las estadísticas.',
      startFailed: 'No se pudo iniciar el juego.',
      playFailed: 'No se pudo jugar la mano.',
      loadDarts: 'No se pudieron cargar los dardos.',
    },
    slots: {
      spin: 'GIRAR',
      win: '¡Ganaste {n}!',
      noWin: '¡Suerte la próxima!',
    },
    blackjack: {
      deal: 'REPARTIR',
      topUp: 'RECARGAR',
      dealer: 'Dealer',
      yourHand: 'Tu mano',
      splitHand: 'Mano dividida',
      bet: 'Apuesta {n}',
      topTier: 'Nivel máximo',
      winsToLevel: '{n} victorias → Nv.{level}',
      playAgain: 'JUGAR DE NUEVO',
      rechargeDiamonds: 'RECARGAR DIAMANTES',
      noDiamondsNext: 'Sin diamantes para la próxima mano',
      emptyTitle: 'Te quedaste sin diamantes',
      emptyBody: 'Recargá para volver a la mesa',
      shortfall: 'Te faltan {n} diamantes para esta apuesta',
      betReturned: 'Apuesta devuelta',
      hit: 'PEDIR',
      stand: 'PLANTARSE',
      double: 'DOBLAR',
      split: 'DIVIDIR',
      outcomeBlackjack: '¡Blackjack!',
      outcomeWin: '¡Ganaste!',
      outcomePush: 'Empate',
      outcomeBust: 'Te pasaste',
      outcomeDealerWins: 'Gana el dealer',
    },
    darts: {
      statusLoading: 'Cargando…',
      statusReady: 'Listo para jugar',
      statusMatchmaking: 'Buscando rival',
      statusInvite: 'Invitación pendiente',
      turnFirst: 'Vos empezás',
      opponentFirst: 'El oponente empieza',
      yourTurn: 'Tu turno - tocá el tablero',
      opponentTurn: 'Turno del oponente',
      victory: '¡Victoria!',
      defeat: 'Derrota',
      error: 'Error',
      findMatch: 'BUSCAR RIVAL',
      inviteFriend: 'Invitá a un amigo',
      opponentId: 'ID de usuario del oponente',
      sendInvite: 'ENVIAR INVITACIÓN',
      inviteSent: '¡Invitación enviada!',
      matchFound: '¡Rival encontrado!',
      youThrowFirst: 'Vos tirás primero',
      opponentThrowsFirst: 'El oponente tira primero',
      you: 'Vos',
      opponent: 'Oponente',
      youWin: '¡Ganaste!',
      youLose: 'Perdiste',
      winner: 'Ganador: {id}',
      playAgain: 'JUGAR DE NUEVO',
      cancel: 'Cancelar',
      finding: 'Buscando oponente…',
      betDiamonds: 'Apuesta: {n} diamantes',
      waitingOpponent: 'Esperando al oponente…',
      dartsCount: 'Dardos: {n}/3',
      throw: 'TIRAR',
      throw3: 'TIRAR 3 DARDOS',
      retry: 'Reintentar',
    },
  },
  live: {
    listTitle: 'En vivo',
    goLive: 'Transmitir',
    loading: 'Cargando transmisiones',
    loadFailed: 'No se pudieron cargar las transmisiones.',
    retry: 'Reintentar',
    empty: 'No hay transmisiones ahora. ¡Sé la primera!',
    watch: 'Ver {title}',
    host: 'Anfitrión {id}',
    joining: 'Uniéndose…',
    joinFailed: 'No se pudo unir a la transmisión',
    tryAgain: 'Intentá de nuevo más tarde.',
    backToLive: 'Volver a en vivo',
    back: 'Volver',
    premium: 'Premium',
    premiumTitle: 'Transmisión premium',
    premiumBody: 'Esta es una transmisión premium. Desbloqueala para ver.',
    balance: 'Saldo: {n} {unit}',
    diamond: 'diamante',
    diamonds: 'diamantes',
    unlocking: 'Desbloqueando…',
    unlockFor: 'Desbloquear por {price}',
    unlockStream: 'Desbloquear transmisión',
    unlockFailed: 'No se pudo desbloquear la transmisión.',
    unlockInsufficient: 'Diamantes insuficientes. Recargá tu saldo para desbloquear.',
    topUp: 'Recargar saldo',
    notFound: 'Transmisión no encontrada',
    notFoundBody: 'Esta transmisión puede haber terminado o no existe.',
    endedTitle: 'Transmisión terminada',
    endedBody: 'Esta transmisión en vivo terminó.',
    suspendedBody: 'Esta transmisión fue suspendida. {reason}',
    preparing: 'Preparando transmisión',
    preparingBody: 'Esperando el token…',
    connected: 'Conectado',
    connectingChat: 'Conectando chat…',
    chatOffline: 'Chat sin conexión',
    giftFailed: 'No se pudo enviar el regalo.',
    sendGift: 'Enviar regalo',
    chatPlaceholder: 'Decí algo…',
    chatSend: 'Enviar mensaje',
    guest: 'Invitado',
    someone: 'Alguien',
    giftSent: '{name} envió {n} 💎',
    giftOverlaySent: 'envió {n} diamantes',
    cameraFailed: 'No se pudo acceder a la cámara.',
    close: 'Cerrar',
    end: 'Terminar',
    cameraOn: 'Encender cámara',
    cameraOff: 'Apagar cámara',
    micOn: 'Activar micrófono',
    micOff: 'Silenciar',
    switchCamera: 'Cambiar cámara',
    sendGiftBtn: 'Enviar regalo',
    giftTitle: 'Enviar diamantes',
    giftSuccess: 'Regalo enviado',
    startTitle: 'Transmitir',
    startBody: 'Usá la pestaña Live de la cámara para configurar.',
    startCta: 'Configurar transmisión',
    finishTitle: 'Terminar transmisión',
    finishBody: '¿Qué querés hacer con esta transmisión?',
    optFree: 'Guardar como post gratis',
    optPremium: 'Guardar como post premium',
    optDiscard: 'Descartar',
    priceError: 'El precio debe estar entre 1 y 1000 diamantes',
    diamondPrice: 'Precio en diamantes',
    cancel: 'Cancelar',
    endStream: 'Terminar',
    preTitle: 'Transmitir',
    streamTitle: 'Título',
    streamPlaceholder: '¿Qué vas a transmitir hoy?',
    visibility: 'Visibilidad',
    visPublic: 'Público',
    visFollowers: 'Seguidores',
    saveAsPost: 'Guardar como post',
    saveAsPostBody: 'Creá un post Live para que tus seguidores lo vean después',
    tags: 'Etiquetas',
    tagsPlaceholder: 'live, musica, preguntas',
    kycRequired: 'El precio premium requiere verificación KYC',
    goLiveCta: 'Transmitir',
    startFailed: 'No se pudo iniciar la transmisión.',
  },
  chat: {
    back: 'Volver',
    chatOptions: 'Opciones del chat',
    connecting: 'Conectando…',
    attachImage: 'Adjuntar imagen',
    imageUploadWip: 'Subida de imágenes aún no implementada',
    typeMessage: 'Escribí un mensaje…',
    send: 'Enviar',
    scrollEnd: 'Ir al final',
    today: 'Hoy',
    yesterday: 'Ayer',
    userFallback: 'Usuario',
    noMessages: 'Sin mensajes todavía',
    typing: 'Escribiendo',
    typingAs: '{name} está escribiendo',
    loadConversations: 'No se pudieron cargar las conversaciones.',
    loadMessages: 'No se pudieron cargar los mensajes.',
    convUnavailable: 'Esta conversación no está disponible.',
    convStartFailed: 'No se pudo iniciar la conversación.',
    typingShort: 'escribiendo…',
    online: 'en línea',
    offline: 'desconectado',
    liveOffline: 'Sin conexión en vivo: {err}',
    retry: 'Reintentar',
    listTitle: 'Mensajes',
    listRetry: 'Reintentar',
    listEmptyTitle: 'Sin mensajes todavía',
    listEmptyBody: 'Empezá una conversación tocando Nuevo mensaje',
    newMessage: 'Nuevo mensaje',
    notDelivered: 'No entregado · tocá para reintentar',
    roomEmptyBody: 'Mandá un mensaje para empezar la conversación',
  },
  reels: {
    createReel: 'Crear reel',
    uploadingReel: 'Subiendo reel',
    selectVideo: 'Seleccionar video',
    changeVideo: 'Cambiar video',
    caption: 'Descripción',
    audioName: 'Audio',
    location: 'Ubicación',
    uploadReel: 'Subir reel',
    createTitle: 'Crear reel',
    uploadDone: '¡Reel subido con éxito!',
    createAnother: 'Crear otro',
    uploadFailed: 'No se pudo subir el reel',
    like: 'Me gusta',
    comment: 'Comentar',
    share: 'Compartir',
    sendGift: 'Enviar regalo',
    emptyTitle: 'Sin reels todavía',
    emptyBody: 'Sé la primera en crear uno',
    errors: {
      noConnection: 'Sin conexión a internet. Intentá de nuevo.',
      sessionExpired: 'Sesión expirada. Iniciá sesión de nuevo.',
      insufficient: 'Diamantes insuficientes o solicitud inválida.',
      fallback: 'Algo salió mal. Intentá de nuevo.',
    },
  },
  search: {
    loadFailed: 'No se pudo cargar la búsqueda',
    startChatFailed: 'No se pudo iniciar la conversación',
    retry: 'Reintentar',
    noUsers: 'Sin usuarios',
    chatHint: 'Buscá usuarios para chatear...',
    startingChat: 'Iniciando chat',
    message: 'Mensaje',
    clearSearch: 'Limpiar búsqueda',
    filters: 'Filtros',
    recentHeader: 'Búsquedas recientes',
    clear: 'Limpiar',
    country: 'País',
    gender: 'Género',
    applyFilters: 'Aplicar filtros',
    allOption: 'Todos',
    opponentId: 'ID de usuario del oponente',
    defaultHint: 'Buscá usuarios...',
  },
  notifications: {
    title: 'Notificaciones',
    markAllRead: 'Marcar todo leído',
    filterLabel: 'Filtro de notificaciones',
    tabAll: 'Todas',
    tabUnread: 'Sin leer',
    retry: 'Reintentar',
    emptyAll: 'Sin notificaciones todavía',
    emptyUnread: 'Sin notificaciones sin leer',
    justNow: 'Ahora mismo',
    minutesAgo: 'hace {n} min',
    hoursAgo: 'hace {n} h',
    daysAgo: 'hace {n} d',
    monthsAgo: 'hace {n} meses',
    yearsAgo: 'hace {n} años',
    loadFailed: 'No se pudieron cargar las notificaciones.',
    kycUpdated: 'Tu verificación de identidad fue actualizada',
    postModerated: 'Tu post fue moderado por un admin',
    pushTitle: 'Notificaciones push',
    pushUnsupported: 'Push no soportado',
    pushUnavailable: 'Push no disponible',
    pushInstallHint: 'Instalá la app para activar push en iOS',
    pushDeniedHint: 'Bloqueado en los ajustes del navegador',
    pushChangeFailed: 'No se pudo cambiar el ajuste de push.',
    pushOn: 'Sí',
    pushOff: 'No',
  },
  onboarding: {
    slide1Title: 'Conoce personas cerca de ti',
    slide1Body: 'Descubre quién está a tu alrededor en tiempo real',
    slide2Title: 'Transmite en vivo',
    slide2Body: 'Comparte tus momentos con el mundo y recibe diamantes',
    slide3Title: 'Gana y gasta diamantes',
    slide3Body: 'Regala, juega y desbloquea contenido exclusivo',
    start: 'Comenzar',
    skip: 'Saltar',
  },
  splash: {
    tagline: 'Conectá con modelos exclusivas',
  },
  nav: {
    home: 'Inicio',
    reels: 'Reels',
    chat: 'Chat',
    profile: 'Perfil',
    search: 'Buscar',
    notifications: 'Notificaciones',
  },
  gifts: {
    title: 'Enviar regalo',
    sent: 'Enviado',
    sending: 'Enviando…',
    tryAgain: 'Intentá de nuevo',
    buyDiamonds: 'Comprar diamantes',
    sendGift: 'Enviar regalo',
    available: 'disponibles',
    decrease: 'Reducir cantidad',
    increase: 'Aumentar cantidad',
  },
  create: {
    newPost: 'Nuevo post',
    post: 'Publicar',
    caption: 'Descripción',
    captionPlaceholder: 'Escribí una descripción...',
    tags: 'Etiquetas',
    tagsPlaceholder: 'viajes, verano, playa',
    dismiss: 'Descartar',
    createFailed: 'No se pudo crear el post',
    uploading: 'Subiendo contenido... {n}%',
    submitting: 'Creando post...',
    premiumPost: 'Post premium',
    premiumOn: 'Los seguidores pagan diamantes para ver este post',
    premiumOff: 'Cualquiera puede ver este post',
    diamondPrice: 'Precio en diamantes',
    pricePlaceholder: '1 - 1000',
    priceError: 'El precio debe estar entre 1 y 1000 diamantes',
    diamondsSuffix: 'diamantes',
    durationError: 'El video excede la duración permitida.',
    tabPhoto: 'Foto',
    tabVideo: 'Video',
    tabLive: 'En vivo',
    cameraUnavailable: 'La cámara no está disponible.',
    close: 'Cerrar',
    cameraPreview: 'Vista previa de cámara',
    captureMode: 'Modo de captura',
    photoCapture: 'Captura de foto',
    videoCapture: 'Captura de video',
    stopRecording: 'Detener grabación',
    capturePhoto: 'Sacar foto',
    recordVideo: 'Grabar video',
    mediaPreview: 'Vista previa del contenido',
    mediaTypeError: 'El tipo de archivo no está soportado.',
    mediaSizeError: 'El archivo excede el tamaño permitido.',
    mediaUnavailable: 'Vista previa no disponible',
  },
  settings: {
    title: 'Configuración',
    account: 'CUENTA',
    editProfile: 'Editar perfil',
    changePassword: 'Cambiar contraseña',
    security: 'SEGURIDAD',
    biometric: 'Face ID / Huella',
    biometricUnavailable: 'Biometría no disponible en este dispositivo',
    pin: 'PIN de acceso',
    devices: 'Dispositivos activos',
    language: 'IDIOMA',
    logoutSection: 'CERRAR SESIÓN',
    logout: 'Cerrar sesión',
    logoutTitle: 'Cerrar sesión',
    logoutCancel: 'Cancelar',
    logoutConfirm: 'Cerrar sesión',
    logoutBody: '¿Estás seguro que deseás cerrar sesión?',
    userFallback: 'Usuario',
    usernameFallback: 'usuario',
    changePasswordTitle: 'Cambiar contraseña',
    pinTitle: 'PIN de acceso',
    devicesTitle: 'Dispositivos activos',
    comingSoon: 'Próximamente',
    currentPassword: 'Contraseña actual',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar nueva contraseña',
    passwordMismatch: 'Las contraseñas no coinciden',
    passwordMin: 'Mínimo 8 caracteres',
    passwordChanged: 'Contraseña cambiada. Iniciá sesión de nuevo.',
    changeCta: 'Cambiar contraseña',
    sessionDevice: 'Dispositivo',
    sessionUnknown: 'Dispositivo desconocido',
    sessionRevoke: 'Cerrar sesión',
    sessionRevokeConfirm: '¿Cerrar esta sesión?',
    sessionCurrentWarn: 'Esta puede ser la sesión que estás usando: también saldrás acá.',
    sessionsEmpty: 'Sin sesiones activas',
    sessionsCount: '{n} sesiones activas',
    pinCreate: 'Crear PIN',
    pinChange: 'Cambiar PIN',
    pinRemove: 'Eliminar PIN',
    pinRemoveConfirm: '¿Eliminar el PIN de acceso de esta cuenta?',
    pinCurrent: 'PIN actual',
    pinNew: 'Nuevo PIN',
    pinCode: 'PIN (4 a 6 dígitos)',
    pinInvalid: 'Ingresá un PIN de 4 a 6 dígitos',
    pinSetOk: 'PIN creado',
    pinChangedOk: 'PIN cambiado',
    pinRemovedOk: 'PIN eliminado',
    pinWrong: 'PIN incorrecto',
    pinSave: 'Guardar',
    lockTitle: 'Ingresá tu PIN',
    lockBody: 'Esta cuenta está protegida con PIN de acceso en este dispositivo.',
    lockUnlock: 'Desbloquear',
    lockWrong: 'PIN incorrecto. Intentá de nuevo.',
    sessionEnded: 'Sesión terminada. Iniciá sesión de nuevo.',
    helpTitle: 'Ayuda',
    helpHeading: '¿En qué te podemos ayudar?',
    helpContact: 'Contactar soporte',
    helpAccount: 'Cuenta y perfil',
    helpAccountBody: 'Editá tu foto, nombre para mostrar, bio y país desde Configuración.',
    helpWallet: 'Wallet y diamantes',
    helpWalletBody: 'Comprá diamantes con tarjeta desde la sección Wallet. La conversión se acredita al instante.',
    helpGames: 'Juegos',
    helpGamesBody: 'Slots, blackjack y darts usan diamantes como moneda. Revisá las reglas antes de apostar.',
    helpPrivacy: 'Privacidad y seguridad',
    helpPrivacyBody: 'Activá biometría y revisá los dispositivos conectados desde Seguridad.',
    helpReport: 'Reportar un problema',
    helpReportBody: 'Si encontrás un bug o comportamiento inadecuado, contactanos y lo revisamos.',
  },
  calls: {
    call: 'Llamar',
    callFree: 'Llamar gratis',
    callRate: 'Llamar · {rate} 💎/min',
    videoCall: 'Videollamada',
    videoCallFree: 'Videollamada gratis',
    videoCallRate: 'Videollamada · {rate} 💎/min',
    callsDisabled: 'No acepta llamadas',
    confirmTitle: 'Confirmar llamada',
    confirmBody: 'Esta llamada cuesta {rate} 💎 por minuto. ¿Querés continuar?',
    confirm: 'Llamar ahora',
    incomingTitle: 'Llamada entrante',
    incomingVideoTitle: 'Videollamada entrante',
    incomingFree: 'Gratis',
    incomingRate: '{rate} 💎/min',
    accept: 'Aceptar',
    reject: 'Rechazar',
    missed: 'Llamada perdida',
    calling: 'Llamando…',
    callingVideo: 'Llamando (video)…',
    cameraOn: 'Encender cámara',
    cameraOff: 'Apagar cámara',
    settingsTitle: 'Llamadas de voz',
    settingsToggle: 'Recibir llamadas',
    rateLabel: 'Precio por minuto (💎)',
    rateHint: '0 = llamadas gratis. Máximo 1000.',
    rateInvalid: 'Ingresá un número entero entre 0 y 1000',
    mute: 'Silenciar',
    unmute: 'Activar micrófono',
    speaker: 'Altavoz',
    endCall: 'Terminar',
    connecting: 'Conectando…',
    cost: 'Costo: {cost} 💎',
    balance: 'Saldo: {balance} 💎',
    perMin: '{rate} 💎/min',
    joinFailed: 'No se pudo unir a la llamada',
    ended: 'Llamada terminada',
    declined: 'Rechazó la llamada',
    cancelled: 'Llamada cancelada',
  },
  feed: {
    errors: {
      noConnection: 'Sin conexión a internet. Intentá de nuevo.',
      sessionExpired: 'Sesión expirada. Iniciá sesión de nuevo.',
      deleteForbidden: 'Solo podés eliminar tus propias publicaciones.',
      postNotFound: 'Publicación no encontrada. Puede que ya esté eliminada.',
      moderateForbidden: 'No tenés permiso para moderar publicaciones.',
      moderateNotFound: 'Publicación no encontrada o ya moderada.',
    },
    screen: {
      retry: 'Reintentar',
      emptyTitle: 'Todavía no hay publicaciones en tu feed',
      emptyBody: 'Tocá actualizar para cargar publicaciones. Asegurate de haber iniciado sesión.',
      refresh: 'Actualizar',
      createPost: 'Crear publicación',
      unlocked: 'Publicación desbloqueada',
      comingSoon: 'Próximamente',
    },
    comments: {
      title: 'Comentarios',
      cancelReply: 'Cancelar respuesta',
      reply: 'Responder',
      replyingTo: 'Respondiendo a {name}',
      sendFailed: 'No se pudo enviar el comentario. Intentá de nuevo.',
      loadFailed: 'No se pudieron cargar los comentarios',
      empty: 'Todavía no hay comentarios',
      retry: 'Reintentar',
      placeholder: 'Agregá un comentario...',
      addLabel: 'Agregar comentario',
      send: 'Enviar',
    },
    post: {
      comments: 'Comentarios',
      share: 'Compartir',
      shareTitle: '{name} en Lolax Models',
      authorProfile: 'Perfil de {name}',
      menuDelete: 'Eliminar',
      menuSuspend: 'Suspender publicación',
      menuAdminDelete: 'Eliminar (admin)',
      deleteTitle: '¿Eliminar esta publicación?',
      deleteBody: 'Esta publicación se eliminará permanentemente de tu feed.',
      cancel: 'Cancelar',
      deleteConfirm: 'Eliminar',
      suspendTitle: '¿Suspender esta publicación?',
      suspendWhy: '¿Por qué suspendés esta publicación?',
      reason: 'Motivo',
      suspendConfirm: 'Suspender',
      adminDeleteTitle: '¿Eliminar esta publicación? (admin)',
      adminDeleteBody:
        'Esta publicación se eliminará permanentemente como acción de moderación, sin importar quién la haya creado.',
    },
    premium: {
      title: 'Contenido premium',
      tapToUnlock: 'Tocá para desbloquear',
      unlockAria: 'Desbloquear contenido premium por {price}',
      diamond: 'diamante',
      diamonds: 'diamantes',
    },
    unlock: {
      title: 'Desbloquear publicación',
      unlockFor: 'Desbloquear por {price} {unit}',
      unlock: 'Desbloquear',
      unlocked: 'Desbloqueado',
      unlocking: 'Desbloqueando…',
      buyDiamonds: 'Comprar diamantes',
      tryAgain: 'Intentá de nuevo',
    },
    unlockErrors: {
      insufficientDiamonds: 'No tenés suficientes diamantes para desbloquear esta publicación',
      alreadyUnlocked: 'Ya desbloqueaste esta publicación',
      postNotFound: 'Publicación no encontrada',
      accessDenied: 'No podés desbloquear esta publicación',
      authRequired: 'Autenticación requerida. Iniciá sesión de nuevo.',
      unlockFailed: 'No se pudo desbloquear. Intentá de nuevo.',
    },
    expand: {
      showMore: 'Ver más',
      showLess: 'Ver menos',
    },
    like: {
      like: 'Me gusta',
      unlike: 'Ya no me gusta',
    },
    media: {
      unauthorized: 'No autorizado',
      unavailable: 'Contenido no disponible',
      failed: 'No se pudo cargar el contenido',
    },
    create: {
      mediaUploadFailed: 'No se pudo subir el contenido',
      createFailed: 'No se pudo crear el post',
      mediaNoId: 'La subida no devolvió un ID de contenido',
    },
  },
}
